// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1PPxw","card":"Cards_card__HoaAl","infected":"Cards_infected__31XHJ","recoverd":"Cards_recoverd__FtCuB","deaths":"Cards_deaths__3EnNW"};